"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrainerStorageServiceInstance = void 0;
const client_1 = require("@rws-framework/client");
const StorageService_1 = __importStar(require("../../../services/StorageService"));
let TrainerStorageService = class TrainerStorageService extends client_1.RWSService {
    constructor(storageService) {
        super();
        this.storageService = storageService;
        this.STORAGE_PREFIX = 'trainer.';
    }
    saveTrainingConfig(config) {
        this.storageService.set(`${this.STORAGE_PREFIX}config`, JSON.stringify(config));
    }
    loadTrainingConfig() {
        const saved = this.storageService.get(`${this.STORAGE_PREFIX}config`);
        return saved ? JSON.parse(saved) : null;
    }
    saveTrainerState(state) {
        const existingState = this.loadTrainerState() || {};
        const newState = { ...existingState, ...state };
        this.storageService.set(`${this.STORAGE_PREFIX}state`, JSON.stringify(newState));
    }
    loadTrainerState() {
        const saved = this.storageService.get(`${this.STORAGE_PREFIX}state`);
        return saved ? JSON.parse(saved) : null;
    }
    saveLastActiveTab(tab) {
        this.storageService.set(`${this.STORAGE_PREFIX}activeTab`, tab);
    }
    loadLastActiveTab() {
        return this.storageService.get(`${this.STORAGE_PREFIX}activeTab`);
    }
    clearTrainerData() {
        // Get all keys from localStorage and filter for trainer keys
        const allKeys = Object.keys(localStorage);
        const trainerKeys = allKeys.filter(key => key.startsWith(this.STORAGE_PREFIX));
        trainerKeys.forEach(key => {
            this.storageService.clear(key);
        });
    }
    clearTrainerState() {
        this.storageService.clear(`${this.STORAGE_PREFIX}state`);
    }
    getDefaultTrainingConfig() {
        return {
            modelName: '',
            baseModel: null,
            useFineTuning: 'lora',
            epochs: 10,
            learningRate: 0.001,
            batchSize: 16,
            validationSplit: 0.2,
            isSent: false
        };
    }
};
exports.TrainerStorageServiceInstance = TrainerStorageService;
exports.TrainerStorageServiceInstance = TrainerStorageService = __decorate([
    __param(0, StorageService_1.default),
    __metadata("design:paramtypes", [typeof (_a = typeof StorageService_1.StorageServiceInstance !== "undefined" && StorageService_1.StorageServiceInstance) === "function" ? _a : Object])
], TrainerStorageService);
exports.default = TrainerStorageService.getSingleton();
